export default {
  communicateCenter_my_circle: '我的圈子',
  communicateCenter_more_circle: '更多圈子',
  communicateCenter_first_more_circle: '去关注你的第一个圈子吧',
  communicateCenter_no_dynamic: '还没有动态',
  communicateCenter_no_nickname: '暂无昵称',
  communicateCenter_from_circle: '来自圈子',
  communicateCenter_total_pics: '共{total}张图片',
  communicateCenter_reply: '个帖子',
  communicateCenter_comment: '{commentCount}个评论',
  communicateCenter_collect: '{collectCount}个收藏',
  communicateCenter_like: '{likeCount}个赞',
}
